import {
  ChannelTypeInternal,
  KeyedFloatValidation,
  SourceThresholdInternal,
} from '../../../../../../../data-access/gql-types/graphql';
import { roundToOne } from '../../../../../../../utils/helpers/number';
import { useDevicesAndChannelsContext } from '../../../../../context/devices-and-channels';

export const useConfigurationValidation = () => {
  const { channel } = useDevicesAndChannelsContext();
  const validationRules = channel?.data.type === ChannelTypeInternal.Meter ? channel.data.validationRules : [];

  const roundStep = (step: number) => {
    if (step <= 0) return 0.01;

    const exponent = Math.floor(Math.log10(step));
    const rounded = (Math.pow(10, exponent) * Math.round((step / Math.pow(10, exponent)) * 100)) / 100;

    return rounded;
  };

  const getValidationRule = (source: SourceThresholdInternal) => {
    const validation = validationRules.find((x) => x.key === source);

    return validation
      ? ({
          key: validation.key,
          hysteresis: {
            min: roundToOne(validation.hysteresis.min),
            max: roundToOne(validation.hysteresis.max),
            step: roundStep(validation.hysteresis.step),
          },
          validation: {
            min: roundToOne(validation.validation.min),
            max: roundToOne(validation.validation.max),
            step: roundStep(validation.validation.step),
          },
        } as KeyedFloatValidation)
      : undefined;
  };

  return {
    getValidationRule,
  };
};
